export default "__VITE_ASSET__bf11ab8e__"